<template>
  <b-form @submit.stop.prevent="onSubmit">
    <b-form-group :label="$t('form.name.label')" label-for="user-register-name">
      <b-input-group>
        <b-input-group-prepend>
          <span class="input-group-text border-right-0">
            <i class="mdi mdi-account text-primary"></i>
          </span>
        </b-input-group-prepend>
        <b-form-input
          id="user-register-name"
          v-model="form.name"
          name="user-register-name"
          :state="validateState('name')"
          aria-describedby="input-name-feedback"
          :placeholder="$t('form.name.label')"
        ></b-form-input>
        <b-form-invalid-feedback id="input-name-feedback">
          {{ $t('message.error.requiredField') }}
        </b-form-invalid-feedback>
      </b-input-group>
    </b-form-group>

    <b-form-group :label="$t('form.surname.label')" label-for="user-register-surname">
      <b-input-group>
        <b-input-group-prepend>
          <span class="input-group-text border-right-0">
            <i class="mdi mdi-account-multiple text-primary"></i>
          </span>
        </b-input-group-prepend>
        <b-form-input
          id="user-register-surname"
          v-model="form.surname"
          name="user-register-surname"
          :placeholder="$t('form.surname.label')"
        ></b-form-input>
      </b-input-group>
    </b-form-group>

    <b-form-group :label="$t('form.email.label')" label-for="user-register-email">
      <b-input-group>
        <b-input-group-prepend>
          <span class="input-group-text border-right-0">
            <i class="mdi mdi-email-outline text-primary"></i>
          </span>
        </b-input-group-prepend>

        <b-form-input
          id="user-register-email"
          v-model="form.email"
          name="user-register-email"
          :state="validateState('email')"
          aria-describedby="input-email-feedback"
          :placeholder="$t('form.email.label')"
        ></b-form-input>
        <b-form-invalid-feedback id="input-email-feedback">
          {{ $t('message.error.invalidEmail') }}
        </b-form-invalid-feedback>
      </b-input-group>
    </b-form-group>

    <phone-number-form-group
      v-model="form.phone"
      :valid-state="form._invalidSave"
      custom-class="register"
      @validate="validatePhone"
    ></phone-number-form-group>

    <b-form-group>
      <hr class="form-hr" />
    </b-form-group>

    <b-form-group :label="$t('form.company.label')" label-for="user-register-company">
      <b-input-group>
        <b-input-group-prepend>
          <span class="input-group-text border-right-0">
            <i class="mdi mdi-bank text-primary"></i>
          </span>
        </b-input-group-prepend>
        <b-form-input
          id="user-register-company"
          v-model="form.company"
          name="user-register-company"
          :state="validateState('company')"
          aria-describedby="input-name-feedback"
          :placeholder="$t('form.company.label')"
        ></b-form-input>
        <b-form-invalid-feedback id="input-name-feedback">
          {{ $t('message.error.requiredField') }}
        </b-form-invalid-feedback>
      </b-input-group>
    </b-form-group>

    <b-form-group :label="$t('form.okpo.label')" label-for="user-register-okpo">
      <b-input-group>
        <b-input-group-prepend>
          <span class="input-group-text border-right-0">
            <i class="mdi mdi-barcode text-primary"></i>
          </span>
        </b-input-group-prepend>
        <b-form-input
          id="user-register-okpo"
          v-model="form.okpo"
          name="user-register-okpo"
          :state="validateState('okpo')"
          aria-describedby="input-okpo-feedback"
          :placeholder="$t('form.okpo.label')"
        ></b-form-input>
        <b-form-invalid-feedback id="okpo-name-feedback">
          {{ $t('message.error.requiredField') }}
        </b-form-invalid-feedback>
      </b-input-group>
    </b-form-group>

    <b-form-group>
      <b-form-checkbox v-model="form.agree" :state="validateState('agree')">
        <i class="input-helper"></i>
        {{ $t('register.form.agree.label') }}
      </b-form-checkbox>
    </b-form-group>

    <div class="my-3">
      <b-button
        type="submit"
        class="btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
        :disabled="processing"
        variant="primary"
      >
        <p v-if="!processing">{{ $t('button.register.label') }}</p>

        <div v-if="processing">
          <b-spinner small type="grow"></b-spinner>
          <b-spinner small type="grow"></b-spinner>
          <b-spinner small type="grow"></b-spinner>
        </div>
      </b-button>
    </div>
  </b-form>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';

export default {
  name: 'SmartOeePmRegisterForm',
  components: {},
  mixins: [validationMixin],
  data() {
    return {
      form: {
        name: '',
        surname: '',
        email: '',
        company: '',
        okpo: '',
        agree: true,
        _isValidPhone: true,
        _invalidSave: false,
      },
    };
  },
  computed: {
    date() {
      return new Date().getFullYear();
    },
    error() {
      return this.$store.getters.getError;
    },
    processing() {
      return this.$store.getters.getProcessing;
    },
    isUserAuthenticated() {
      return this.$authCore.isAuthenticated;
    },
  },
  watch: {
    isUserAuthenticated(val) {
      if (val) {
        this.$routerCore.GoToHomePage();
      }
    },
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
      _isValidPhone: {
        required,
        valid: (value) => value === true,
      },
      name: {
        required,
      },
      company: {
        required,
      },
      phone: {
        required,
      },
      okpo: {
        required,
      },
      agree: {
        checked: (value) => value === true,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validatePhone(is) {
      this.form._isValidPhone = is;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        this.form._invalidSave = true;
        return;
      }
      this.$store.commit('SET_PROCESSING', true);
      this.$emit('submit', this.form);
    },
  },
};
</script>
<style lang="scss" scoped>
.form-hr {
  background-color: #2c2e33;
}
</style>
